import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AccessControlService {
  private accessControlData: any[] = [];

  constructor() {}

  setAccessControlData(data: any[]): void {
    this.accessControlData = data;
  }

  canRead(subModuleName: string): boolean {
    return this.checkAccess(subModuleName, 'read');
  }

  canWrite(subModuleName: string): boolean {
    // console.log('________________',subModuleName)
    return this.checkAccess(subModuleName, 'write');
  }

  canUpdate(subModuleName: string): boolean {
    return this.checkAccess(subModuleName, 'update');
  }

  private checkAccess(subModuleName: string, accessType: string): boolean {
    // console.log('________________',subModuleName)
    for (const module of this.accessControlData) {
      // console.log(module.moduleName,subModuleName,'=====')
      const md = module.moduleName == subModuleName
      // console.log('________________',module.moduleName,module[accessType])
      if ( md && module[accessType]  === true) {
        return true;
        }
      if (!module.submodulePermissions || module.submodulePermissions.length === 0) {
        continue;
      }
      // console.log('________________',module.submodulePermissions)
      const subModule = module.submodulePermissions.find(
        (sm: any) => sm.subModuleName === subModuleName
      );
      if (subModule && subModule[accessType] === true) {
        return true;
      }
    }
    return false;
  }
}
